import { Column, Row, Section } from '@react-email/components'

import { borderRadius } from '@ms-email/themes/border-radius'

export function SplitContent(props) {
  const { first, second } = props

  return (
    <Section
      style={{
        marginTop: 32,
        border: 'solid 1px',
        borderColor: 'rgba(0, 0, 0, 0.2)',
        borderRadius: borderRadius.rounded
      }}
    >
      {first}
      <Row>
        <Column>
          <div
            style={{
              height: 1,
              backgroundColor: 'rgba(0, 0, 0, 0.2)'
            }}
          />
        </Column>
      </Row>
      {second}
    </Section>
  )
}
